import { STORE_PREFIX } from "@/routes_new/outer/interview/landing/prepare/constants.js";
// import landing_store from "@/stores_new/landing/index.js";
import interview_store from "@/stores_new/interview_new/index.js";

export default {
  created() {
    // if (
    //   !(
    //     this.$store &&
    //     this.$store.state &&
    //     this.$store.state[STORE_PREFIX + "landing"]
    //   )
    // ) {
    //   this.$store.registerModule(STORE_PREFIX + "landing", landing_store);
    // }
    if (
      !(
        this.$store &&
        this.$store.state &&
        this.$store.state[STORE_PREFIX + "interview"]
      )
    ) {
      this.$store.registerModule(STORE_PREFIX + "interview", interview_store);
    }
  }
};
